// frontend/src/lib/returnNav.ts
import { useSearchParams } from 'react-router-dom'
import { sanitizeReturnTo } from './authRedirect'

export interface BackTarget {
  to: string
  label: string
}

const MAX_LABEL_LEN = 40

/**
 * Resolve the back-affordance target for the current page (LW-9).
 * - A sanitized `returnTo` search param wins; its label is `returnLabel` (trimmed, clamped)
 *   or 'Back'. Validation is delegated to `sanitizeReturnTo` (root-relative, same-origin).
 * - else the page's `fallback` default, if supplied.
 * - else null → the page renders no back affordance.
 * `returnLabel` is display-only and never used for navigation.
 */
export function useReturnTo(fallback?: BackTarget): BackTarget | null {
  const [searchParams] = useSearchParams()
  const to = sanitizeReturnTo(searchParams.get('returnTo'))
  if (to) {
    const label = (searchParams.get('returnLabel') ?? '').trim().slice(0, MAX_LABEL_LEN) || 'Back'
    return { to, label }
  }
  return fallback ?? null
}
